import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Card, Icon, Grid } from 'semantic-ui-react';
import classNames from 'classnames';

import 'Styles/components/titled-card.less';

const TitledCard = ({
  title,
  rightItem,
  children,
  style,
  headerClass,
  headerStyle,
  leftColProps = {},
  rightColProps = {},
  tight,
  collapsible = false,
  defaultCollapsed = false,
  ...rest
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const header = (
    <Card.Header className={headerClass} style={headerStyle}>
      <Grid>
        <Grid.Row>
          <Grid.Column
            width={8}
            textAlign={'left'}
            className={'titled-card-header'}
            {...leftColProps}
          >
            {collapsible && <Icon name="dropdown" />}
            <label
              className={classNames('text-orange', {
                'cursor-pointer': collapsible,
              })}
            >
              {title}
            </label>
          </Grid.Column>
          <Grid.Column
            width={8}
            className={'right-items-container'}
            {...rightColProps}
          >
            {rightItem}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Header>
  );

  const accordion = (
    <Accordion>
      <Accordion.Title
        className="accordion-title"
        index={0}
        active={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        {header}
      </Accordion.Title>
      <Accordion.Content index={0} active={!collapsed}>
        {children}
      </Accordion.Content>
    </Accordion>
  );

  // if collapsible, render the accordion
  const content = collapsible ? (
    accordion
  ) : (
    <React.Fragment>
      {header}
      {children}
    </React.Fragment>
  );

  return (
    <Card.Group
      itemsPerRow={1}
      className={classNames('titled-card', { tight })}
      style={style}
      {...rest}
    >
      <Card raised>
        <Card.Content
          className={classNames({
            'p-t-0': collapsible,
            'p-b-0': collapsible && collapsed,
          })}
        >
          {content}
        </Card.Content>
      </Card>
    </Card.Group>
  );
};

TitledCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  rightItem: PropTypes.any,
  children: PropTypes.any,
  style: PropTypes.object,
  headerClass: PropTypes.string,
  headerStyle: PropTypes.object,
  leftColProps: PropTypes.object,
  rightColProps: PropTypes.object,
  tight: PropTypes.bool,
  /**
   * Allows card to act as an accordion
   */
  collapsible: PropTypes.bool,
  /**
   * Initial accordion collapsed state
   */
  defaultCollapsed: PropTypes.bool,
};

TitledCard.defaultProps = {
  title: '',
  style: {},
  leftColProps: {},
  rightColProps: {},
  tight: false,
  collapsible: false,
  defaultCollapsed: false,
};

export { TitledCard };



// WEBPACK FOOTER //
// ./src/components/layout/TitledCard.js